import { render, staticRenderFns } from "./ConfigAnnounce.vue?vue&type=template&id=0b50218f&scoped=true&"
import script from "./ConfigAnnounce.vue?vue&type=script&lang=js&"
export * from "./ConfigAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAnnounce.vue?vue&type=style&index=0&id=0b50218f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50218f",
  null
  
)

export default component.exports